var _rect, _metadata, _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    width: 1000,
    height: 1000,
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    className: "selected",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M867.5,135.8H663.3v-51c0-41.3-33.4-74.8-74.8-74.8H411.2c-41.1,0-74.5,33.4-74.5,74.8v51H132.5v37.5h53.8l60.2,741.9c0,41.3,33.4,74.8,74.8,74.8h359.8c41.3,0,74.8-33.4,74.8-74.8l59.5-741.9h52.1V135.8z M373.9,84.8c0-20.7,16.8-37.5,37.3-37.5h177.4c20.7,0,37.3,16.8,37.3,37.5v51H373.9V84.8z M718.5,913.2v1v1c0,20.7-16.8,37.5-37.3,37.5H321.4c-20.7,0-37.3-16.8-37.3-37.5v-1v-1l-60.5-739.8h554.3L718.5,913.2z",
    id: "svg_2",
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.1,255h35.7v615.1h-35.7V255z",
    id: "svg_3",
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.3,255h-37.3l-27.3,615.1H636L663.3,255z",
    id: "svg_4",
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.7,255h-37L364,870.1h37.3L373.7,255z",
    id: "svg_5",
    fill: "#ffffff",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.a11bcf11dee79fbb3bcbcc744e60310f.svg";
export { ForwardRef as ReactComponent };